<form [formGroup]="form" (ngSubmit)="login()">
  <un-input
    type="email"
    formControlName="email"
    label="Email"
    i18n-label="@@email"
  ></un-input>
  <un-input
    type="password"
    formControlName="password"
    label="Password"
    i18n-label="@@password"
    labeInfoText="Enter your password or click on forget password to reset"
    i18n-labeInfoText
  ></un-input>

  <re-captcha
    class="m-b-12 m-t-12"
    (resolved)="resolveRecaptcha($event)"
    [siteKey]="recaptchaKey"
  ></re-captcha>

  <button class="primary large t-large" type="submit" i18n>Login</button>
</form>

<div class="register">
  <a
    [routerLink]="forgotPasswordLink"
    queryParamsHandling="merge"
    (click)="modalRef?.close({ resetPassword: true })"
    i18n="@@forgotYourPassword"
    >Forgot your password?</a
  >
</div>
<div class="d-flex social-auth">
  <a (click)="oauth('google')"
    ><span i18n>Login with google</span> <fa-icon [icon]="faGoogle"></fa-icon
  ></a>
  <!-- <a (click)="oauth('facebook')"><fa-icon [icon]="faFacebook"></fa-icon></a> -->
</div>

<a
  [routerLink]="registerLink"
  queryParamsHandling="merge"
  class="c-primary"
  (click)="modalRef?.close({ register: true })"
>
  <strong i18n="@@registerAsAStudent">Register as a student</strong>
</a>
